function requestCartRefresh(open) {
  document.dispatchEvent(new CustomEvent('vd:cart-refresh', { detail: { open } }));
}

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({ eventTarget: () => document });
  actions.openCart.configure({
    async handler() {
      if (document.querySelector('[data-vd-cart-drawer]')) {
        requestCartRefresh(true);
        return;
      }
      window.location.href = typeof Theme !== 'undefined' ? Theme.routes.cart_url : '/cart';
    },
  });
}

document.addEventListener('shopify:cart:lines-update', (event) => {
  if (!document.querySelector('[data-vd-cart-drawer]')) return;
  const sourceModal = event.target instanceof Element ? event.target.closest('dialog:modal') : null;
  event.promise?.then(({ detail, userErrors }) => {
    if (detail?.didError || userErrors?.length) return;
    const open = event.action === 'add';
    if (open && sourceModal?.open) {
      sourceModal.addEventListener('close', () => requestCartRefresh(true), { once: true });
    } else {
      requestCartRefresh(open);
    }
  }).catch(() => {});
});

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
